module.exports = __webpack_public_path__ + "images/category_lp/watch/reason3_323ad248f766974d740d8dab6945c5fe.png";